module.exports = __webpack_public_path__ + "img/30_41.7d71a4d5.png";